module.exports = [
	{
		"id": "19952000",
		"image": "//cdn.cloud.grohe.com/prod/10/19/19952000/640/19952000.jpg",
		"headline": "Talentofill",
		"subheadline": "Badvul-, afvoer- en overloopgarnituur",
		"textblock_1st_text": "19952000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/19952000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "23147001",
		"image": "//cdn.cloud.grohe.com/prod/20/23/23147001/640/23147001.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Douchesysteem met ééngreepsmengkraan",
		"textblock_1st_text": "23147001",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL-douchesysteem met eengreepsmengkraan; chroom en Duitse kwaliteit, met metalen hoofddouche van 230 mm en handdouche met één straal.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/23147001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13280001",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13280001/640/13280001.jpg",
		"headline": "Concetto",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13280001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/13280001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G187",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34506000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34506000/640/34506000.jpg",
		"headline": "Grohtherm Cube",
		"subheadline": "Inbouwdouchesysteem Rainshower Allure 230",
		"textblock_1st_text": "34506000",
		"textblock_2nd_text": "GROHE Grohtherm Cube Perfect Shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34506000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G387",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34195001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34195001/640/34195001.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Thermostatische douchekraan 1/2\" met doucheset",
		"textblock_1st_text": "34195001",
		"textblock_2nd_text": "Grohtherm 2000 douchethermostaat met GROHE Euphoria doucheset (bestaat uit een 110 mm handdouche met drie straalsoorten, 600 mm glijstang, 1750 mm doucheslang en zeepschaal)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34195001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27032001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27032001/640/27032001.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27032001",
		"textblock_2nd_text": "GROHE Rainshower 210-douchesysteem met thermostaat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27032001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27074000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27074000/640/27074000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wanddouchehouder",
		"textblock_1st_text": "27074000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27074000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27058000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27058000/640/27058000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met omsteller",
		"textblock_1st_text": "27058000",
		"textblock_2nd_text": "GROHE Rainshower Modern douchesysteem 210 met omschakeling",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27058000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27057000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27057000/640/27057000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "27057000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27057000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26087000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26087000/640/26087000.jpg",
		"headline": "Euphoria Cube System 230",
		"subheadline": "Douchesysteem met thermostatische kraan, wandmontage",
		"textblock_1st_text": "26087000",
		"textblock_2nd_text": "GROHE Euphoria Cube XXL 230 mm douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26087000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G365",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27055000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27055000/640/27055000.jpg",
		"headline": "Rainshower",
		"subheadline": "Wanddouchehouder",
		"textblock_1st_text": "27055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27368000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27368000/640/27368000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Doucheset",
		"textblock_1st_text": "27368000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27368000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27374000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27374000/640/27374000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostaat en zijdouches",
		"textblock_1st_text": "27374000",
		"textblock_2nd_text": "GROHE Rainshower Modern douchesysteem 210 met thermostaatkraan en zijdouches",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27374000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26066000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26066000/640/26066000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset 380 mm, 1 straalsoort",
		"textblock_1st_text": "26066000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26066000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26067000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26067000/640/26067000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset, 142 mm, 1 straal",
		"textblock_1st_text": "26067000",
		"textblock_2nd_text": "Rainshower® Cosmopolitan 310, hoofddoucheset, plafond-douchearm 142 mm, 9,5 L/min",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26067000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26065000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26065000/640/26065000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hoofddoucheset plafond 154 mm, 1 straalsoort",
		"textblock_1st_text": "26065000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26065000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26064000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26064000/640/26064000.jpg",
		"headline": "Rainshower Allure 230",
		"subheadline": "Hoofddoucheset, 286 mm, 1 straal",
		"textblock_1st_text": "26064000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26064000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G363",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26075000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26075000/640/26075000.jpg",
		"headline": "Euphoria System 310",
		"subheadline": "Douchesysteem met thermostatische kraan, wandmontage",
		"textblock_1st_text": "26075000",
		"textblock_2nd_text": "GROHE  Euphoria XXL douchesysteem met thermostaat. Chroom, in Duitsland ontwikkeld met 310 mm douchekop en waterbesparende 110 mm handdouche met drie stralen.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26075000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27251000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27251000/640/27251000.jpg",
		"headline": "Rainshower F-Series 5'",
		"subheadline": "Zijdouche",
		"textblock_1st_text": "27251000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27251000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G231",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27492000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27492000/640/27492000.jpg",
		"headline": "Euphoria Cosmopolitan 180",
		"subheadline": "Hoofddouche",
		"textblock_1st_text": "27492000",
		"textblock_2nd_text": "GROHE Euphoria Cosmopolitan 180 mm hoofddouche, 9,5 l/min.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27492000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26073000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26073000/640/26073000.jpg",
		"headline": "Euphoria Cube 150",
		"subheadline": "Hoofddoucheset, 286 mm, 1 straal",
		"textblock_1st_text": "26073000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26073000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250000/640/26250000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "26250000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 DUO douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361000/640/26361000.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "26361000",
		"textblock_2nd_text": "GROHE Rainshower® SmartControl 360 MONO douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27755000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27755000/640/27755000.jpg",
		"headline": "Power&Soul Cosmopolitan 115",
		"subheadline": "Doucheset 2 stralen",
		"textblock_1st_text": "27755000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27755000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27759000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27759000/640/27759000.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Doucheset 2 stralen",
		"textblock_1st_text": "27759000",
		"textblock_2nd_text": "GROHE Power&Soul-set met handdouche (115 mm), doucherail (900 mm) en doucheslang (1,750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27759000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27784000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27784000/640/27784000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Douchestang 600 mm",
		"textblock_1st_text": "27784000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27784000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27785000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27785000/640/27785000.jpg",
		"headline": "Power&Soul",
		"subheadline": "Douchestang 900 mm",
		"textblock_1st_text": "27785000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27785000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13303000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13303000/640/13303000.jpg",
		"headline": "Eurocube",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13303000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/13303000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G320",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27699000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27699000/640/27699000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27699000",
		"textblock_2nd_text": "Euphoria Cube Stick, handdouche, 1 straal",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27699000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27704000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27704000/640/27704000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "27704000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27704000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27968000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27968000/640/27968000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27968000",
		"textblock_2nd_text": "GROHE Rainshower 310-douchesysteem met thermostaat",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27968000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27967000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27967000/640/27967000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27967000",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 210 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27967000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28364000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28364000/640/28364000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang Twistfree 1500",
		"textblock_1st_text": "28364000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1500 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28364000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28362000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28362000/640/28362000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang Twistfree 1250",
		"textblock_1st_text": "28362000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1250 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28362000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28576000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28576000/640/28576000.jpg",
		"headline": "Rainshower",
		"subheadline": "Douche-arm 286 mm",
		"textblock_1st_text": "28576000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28576000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G090",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27966000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27966000/640/27966000.jpg",
		"headline": "Rainshower System 310",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27966000",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 310 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27966000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28388000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28388000/640/28388000.jpg",
		"headline": "Silverflex",
		"subheadline": "Doucheslang Twistfree 1750",
		"textblock_1st_text": "28388000",
		"textblock_2nd_text": "GROHE Silverflex doucheslang met draaibare aansluiting voor TwistFree functie, 1750 mm",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28388000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "28990000",
		"image": "//cdn.cloud.grohe.com/prod/20/28/28990000/640/28990000.jpg",
		"headline": "Talentofill",
		"subheadline": "Badvul-, afvoer- en overloopgarnituur",
		"textblock_1st_text": "28990000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/28990000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=X999",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27700000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27700000/640/27700000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Doucheset",
		"textblock_1st_text": "27700000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27700000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34630000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34630000/640/34630000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect Shower Set Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34630000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34630000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26053LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26053LS0/640/26053LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hoofddoucheset, 142 mm, 1 straal",
		"textblock_1st_text": "26053LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26053LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27663LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27663LS0/640/27663LS0.jpg",
		"headline": "Power&Soul Cosmopolitan 130",
		"subheadline": "Handdouche 4+ stralen",
		"textblock_1st_text": "27663LS0",
		"textblock_2nd_text": "Power&Soul® Cosmopolitan 130, handdouche, 4+ stralen",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27663LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27174001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27174001/640/27174001.jpg",
		"headline": "Rainshower System 400",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27174001",
		"textblock_2nd_text": "GROHE Rainshower douchesysteem 400 met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27174001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27641000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27641000/640/27641000.jpg",
		"headline": "Rainshower System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan bad/douche",
		"textblock_1st_text": "27641000",
		"textblock_2nd_text": "GROHE Rainshower 210 douchesysteem met badthermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27641000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G212",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34631000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34631000/640/34631000.jpg",
		"headline": "Grohtherm 2000",
		"subheadline": "Perfect Shower set met Rainshower® Cosmopolitan 210",
		"textblock_1st_text": "34631000",
		"textblock_2nd_text": "GROHE Grohtherm 2000 Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34631000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G367",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27673LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27673LS0/640/27673LS0.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Handdouche 4+ stralen, sproeiplaat wit",
		"textblock_1st_text": "27673LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27673LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27671LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27671LS0/640/27671LS0.jpg",
		"headline": "Power&Soul 115",
		"subheadline": "Handdouche 2 stralen, sproeiplaat wit",
		"textblock_1st_text": "27671LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27671LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450LS0/640/26450LS0.jpg",
		"headline": "Rainshower Mono 360",
		"subheadline": "Hoofddoucheset 450 mm, 1 straal",
		"textblock_1st_text": "26450LS0",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO hoofddoucheset. Chroom, gefabriceerd in Duitsland: 360 mm hoofddouche (witte sproeiplaat) en een 450 mm douchearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26450LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26450000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26450000/640/26450000.jpg",
		"headline": "Rainshower Mono 360",
		"subheadline": "Hoofddoucheset 450 mm, 1 straal",
		"textblock_1st_text": "26450000",
		"textblock_2nd_text": "GROHE Rainshower 360 MONO hoofddoucheset. Chroom, gefabriceerd in Duitsland: 360mm hoofddouche en een 450mm douchearm.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26450000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26361LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26361LS0/640/26361LS0.jpg",
		"headline": "Rainshower System SmartControl Mono 360",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "26361LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 MONO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360 mm hoofddouche (witte sproeiplaat) en een 115mm handdouche met vier straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26361LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27738000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27738000/640/27738000.jpg",
		"headline": "Power&Soul 130",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27738000",
		"textblock_2nd_text": "GROHE Power&Soul doucheset met handdouche, 9,5 l/min (130 mm), glijstang (900 mm) en doucheslang (1750 mm)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27738000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G316",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26056000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26056000/640/26056000.jpg",
		"headline": "Rainshower Cosmopolitan 310",
		"subheadline": "Hoofddoucheset 380 mm, 1 straalsoort",
		"textblock_1st_text": "26056000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26056000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26171LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26171LS0/640/26171LS0.jpg",
		"headline": "Rainshower Cosmopolitan 210",
		"subheadline": "Hoofddoucheset 422 mm, 1 straal",
		"textblock_1st_text": "26171LS0",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26171LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G372",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34627000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34627000/640/34627000.jpg",
		"headline": "Grohtherm 3000 Cosmopolitan",
		"subheadline": "Perfect Shower Set Rainshower Cosmopolitan 310",
		"textblock_1st_text": "34627000",
		"textblock_2nd_text": "GROHE Grohtherm 3000 Cosmopolitan Perfect shower set, inclusief thermostatische inbouwkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34627000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G202",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "13242000",
		"image": "//cdn.cloud.grohe.com/prod/10/13/13242000/640/13242000.jpg",
		"headline": "Veris",
		"subheadline": "Baduitloop",
		"textblock_1st_text": "13242000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/13242000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G228",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27964000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27964000/640/27964000.jpg",
		"headline": "Euphoria System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27964000",
		"textblock_2nd_text": "GROHE Euphoria 210 douchesysteem met thermostaatkraan",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27964000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27367000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27367000/640/27367000.jpg",
		"headline": "Euphoria Cosmopolitan Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27367000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27367000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G275",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27698000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27698000/640/27698000.jpg",
		"headline": "Euphoria Cube Stick",
		"subheadline": "Handdouche, 1 straal",
		"textblock_1st_text": "27698000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27698000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27744000",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27744000/640/27744000.jpg",
		"headline": "Power&Soul Cosmopolitan 160",
		"subheadline": "Doucheset 4+ stralen",
		"textblock_1st_text": "27744000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27744000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G315",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29150LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29150LS0/640/29150LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29150LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29150LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29151LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29151LS0/640/29151LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29151LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29151LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29904LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29904LS0/640/29904LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29904LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29904LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26458000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26458000/640/26458000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hoofddoucheset 380 mm, 3 stralen",
		"textblock_1st_text": "26458000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl-hoofddoucheset met drie straalzones. Douchekop van 260 mm en GROHE Rainshower-arm (380 mm) met chroomafwerking. Eenvoudig te installeren en onderhouden. Gemaakt in Duitsland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26458000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26223001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26223001/640/26223001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan bad/douche",
		"textblock_1st_text": "26223001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 douchesysteem met badthermostaat, 210 mm hoofddouche en een 100 mm  handdouche met twee straalsoorten. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26223001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "25183001",
		"image": "//cdn.cloud.grohe.com/prod/20/25/25183001/640/25183001.jpg",
		"headline": "Eurosmart Cosmopolitan",
		"subheadline": "Perfect Shower Set Tempesta",
		"textblock_1st_text": "25183001",
		"textblock_2nd_text": "GROHE Eurosmart Cosmopolitan Perfect-doucheset met eengreepsmengkraan voor onzichtbare installatie, hoofddouche van 210 mm en handdouche van 100 mm met twee stralen in chroomafwerking.  Duitse technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/25183001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G267",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26381001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26381001/640/26381001.jpg",
		"headline": "Tempesta System 210",
		"subheadline": "Flex Shower System met omsteller voor wandmontage",
		"textblock_1st_text": "26381001",
		"textblock_2nd_text": "GROHE New Tempesta 210 FLEX douchesysteem met omstelkraan; compatibel met alle bestaande aansluitingen voor een eenvoudige upgrade. Geproduceerd in Duitsland met een 210 mm hoofddouche met twee straalsoorten en een 100 mm handdouche.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26381001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G391",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29123000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29123000/640/29123000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29123000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29123000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "35600000",
		"image": "//cdn.cloud.grohe.com/prod/30/35/35600000/640/35600000.jpg",
		"headline": "GROHE Rapido SmartBox",
		"subheadline": "universele inbouwbox, 1/2\"",
		"textblock_1st_text": "35600000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/35600000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29119000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29119000/640/29119000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29119000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (356000000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29119000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29120000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29120000/640/29120000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen en geïntegreerde douchehouder",
		"textblock_1st_text": "29120000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Met douchehouder. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29120000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29121000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29121000/640/29121000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29121000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29121000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29124000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29124000/640/29124000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29124000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29124000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29125000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29125000/640/29125000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen en geïntegreerde douchehouder",
		"textblock_1st_text": "29125000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Met douchehouder. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29125000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29126000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29126000/640/29126000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29126000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29126000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26250LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26250LS0/640/26250LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "26250LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO wandmontage douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland, 360mm hoofddouche witte  sproeiplaat met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26250LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "14055000",
		"image": "//cdn.cloud.grohe.com/prod/10/14/14055000/640/14055000.jpg",
		"headline": "",
		"subheadline": "Terugstroombeveiligingscombinatie voor Talentofill (DIN EN1717)",
		"textblock_1st_text": "14055000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/14055000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G452",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479LS0/640/26479LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten",
		"textblock_1st_text": "26479LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom en witte sproeiplaat, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26479LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26479000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26479000/640/26479000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten",
		"textblock_1st_text": "26479000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26479000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477LS0/640/26477LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26477LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom en witte sproeiplaat, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26477LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26477000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26477000/640/26477000.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26477000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26477000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26475LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26475LS0/640/26475LS0.jpg",
		"headline": "Rainshower SmartActive 310",
		"subheadline": "Hoofddoucheset 430 mm, 2 straalsoorten",
		"textblock_1st_text": "26475LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive hoofddoucheset met 2 straalsoorten. 310 mm wandgemonteerde douchekop met 400 mm douchearm, chroom en witte sproeiplaat, rond. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26475LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26449000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26449000/640/26449000.jpg",
		"headline": "",
		"subheadline": "Rainshower SmartControl inbouwunit voor inbouw/opbouw-varianten",
		"textblock_1st_text": "26449000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26449000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G216",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443LS0/640/26443LS0.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443LS0",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360mm hoofddouche (witte sproeiplaat) met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26443000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26443000/640/26443000.jpg",
		"headline": "Rainshower System SmartControl Duo 360",
		"subheadline": "Combi douchesysteem met thermostaat, voor opbouw/inbouw",
		"textblock_1st_text": "26443000",
		"textblock_2nd_text": "GROHE Rainshower SmartControl 360 DUO Combi douchesysteem met thermostaatkraan. Chroom, milieuvriendelijk en gefabriceerd in Duitsland: 360 mm hoofddouche met GROHE TrioMassage straal en een 115mm handdouche met twee straalsoorten.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26443000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26483000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26483000/640/26483000.jpg",
		"headline": "Rainshower",
		"subheadline": "universele inbouwbox, 1/2\"",
		"textblock_1st_text": "26483000",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26483000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481LS0/640/26481LS0.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26481LS0",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom en witte sproeiplaat, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26481LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26481000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26481000/640/26481000.jpg",
		"headline": "Rainshower SmartActive 310 Cube",
		"subheadline": "Hoofddoucheset plafond 142 mm, 2 straalsoorten",
		"textblock_1st_text": "26481000",
		"textblock_2nd_text": "GROHE Rainshower 310 SmartActive CUBE hoofddoucheset met 2 straalsoorten. 310 mm plafondgemonteerde douchekop met 142 mm douchearm, chroom, vierkant. Gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26481000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G480",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34614001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34614001/640/34614001.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Perfect Shower Set Tempesta",
		"textblock_1st_text": "34614001",
		"textblock_2nd_text": "GROHE Grohtherm 1000 Perfect Shower set met 210 mm hoofddouche en een 100 mm chromen handdouche met twee straalsoorten. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34614001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27922001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27922001/640/27922001.jpg",
		"headline": "Tempesta Cosmopolitan System 210",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27922001",
		"textblock_2nd_text": "GROHE Tempesta Cosmopolitan 210 Douchesysteem met thermostaat, 210 mm hoofddouche en een 100mm chroom handdouche met twee straalsoorten. Hij is eenvoudig te installeren en te reinigen. Gemaakt met Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27922001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G361",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29153LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29153LS0/640/29153LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29153LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29153LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29156LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29156LS0/640/29156LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 2 uitgangen",
		"textblock_1st_text": "29156LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 2 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29156LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29157LS0",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29157LS0/640/29157LS0.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 3 uitgangen",
		"textblock_1st_text": "29157LS0",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan met 3 knoppen voor bediening van bijv. hoofddouche, handdouche, zijdouche, baduitloop, of andere straalsoort. Excl. inbouwdeel (35600000). Vierkante vorm, chroom/wit.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29157LS0",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27475001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27475001/640/27475001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met thermostatische mengkraan bad/douche",
		"textblock_1st_text": "27475001",
		"textblock_2nd_text": "GROHE Euphoria 260 Douchesysteem met thermostaat voor baduitloop, waterbesparende SmartControl 260 mm hoofddouche met drie stralen en een 110 mm chroom handdouche met drie stralen. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27475001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27421002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27421002/640/27421002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met omsteller",
		"textblock_1st_text": "27421002",
		"textblock_2nd_text": "GROHE Euphoria 260 douchesysteem met omschakeling. Waterbesparende SmartControl 260 mm hoofddouche met drie straalsoorten en een 110 mm chromen handdouche met drie straalsoorten. Geproduceerd in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27421002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27296002",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27296002/640/27296002.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27296002",
		"textblock_2nd_text": "GROHE Euphoria 260-douchesysteem met thermostaat, hoofddouche van 260 mm met 3 stralen en handdouche van 110 mm met 3 stralen in chroomafwerking. Eenvoudig te installeren en onderhouden. Duitse technologie",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27296002",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26460000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26460000/640/26460000.jpg",
		"headline": "Euphoria 260",
		"subheadline": "Hoofddoucheset plafondmontage 142 mm, 3 stralen",
		"textblock_1st_text": "26460000",
		"textblock_2nd_text": "GROHE Euphoria 260 SmartControl-hoofddoucheset met drie straalzones. Douchekop van 260 mm en GROHE Rainshower-plafondarm (142 mm) met chroomafwerking. Eenvoudig te installeren en onderhouden. Gemaakt in Duitsland",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26460000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G204",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34151004",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34151004/640/34151004.jpg",
		"headline": "Grohtherm 1000",
		"subheadline": "Thermostatische douchekraan 1/2\" met doucheset",
		"textblock_1st_text": "34151004",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34151004",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G413",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34566001",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34566001/640/34566001.jpg",
		"headline": "Grohtherm 800",
		"subheadline": "Thermostatische douchekraan 1/2\" met doucheset",
		"textblock_1st_text": "34566001",
		"textblock_2nd_text": "Grohtherm 800 douchethermostaat met GROHE New Tempesta doucheset (bestaat uit een 100 mm handdouche met twee straalsoorten, 900 mm glijstang en 1750 mm doucheslang)",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34566001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G414",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "29118000",
		"image": "//cdn.cloud.grohe.com/prod/20/29/29118000/640/29118000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Inbouwthermostaat met 1 uitgang",
		"textblock_1st_text": "29118000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouw thermostaatkraan voor douche. Excl. inbouwdeel (35600000). Ronde vorm, chroom.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/29118000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "27615001",
		"image": "//cdn.cloud.grohe.com/prod/20/27/27615001/640/27615001.jpg",
		"headline": "Euphoria System 260",
		"subheadline": "Douchesysteem met thermostatische mengkraan",
		"textblock_1st_text": "27615001",
		"textblock_2nd_text": "GROHE Euphoria 260 Douchesysteem met thermostaat, waterbesparende SmartControl 260 mm hoofddouche met drie stralen en een 110 mm chroom handdouche met drie stralen. Hij is eenvoudig te installeren en te reinigen. Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/27615001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G236",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34705000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34705000/640/34705000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set met Rainshower SmartActive 310",
		"textblock_1st_text": "34705000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouwdouche met thermostaatkraan, hoofddouche en handdouche. Ronde vorm. Chroom afwerking, gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34705000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34706000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34706000/640/34706000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Perfect shower set met Rainshower SmartActive 310 Cube",
		"textblock_1st_text": "34706000",
		"textblock_2nd_text": "Grohtherm SmartControl inbouwdouche met thermostaatkraan, hoofddouche en handdouche. Vierkante vorm. Chroom afwerking, gemaakt in Duitsland.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34706000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26264001",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26264001/640/26264001.jpg",
		"headline": "Rainshower 360",
		"subheadline": "Inbouwbox voor hoofddoucheset 26 254 / 26 450",
		"textblock_1st_text": "26264001",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26264001",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G421",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "26370000",
		"image": "//cdn.cloud.grohe.com/prod/20/26/26370000/640/26370000.jpg",
		"headline": "Euphoria Cube",
		"subheadline": "Wandaansluitbocht 1/2\"",
		"textblock_1st_text": "26370000",
		"textblock_2nd_text": "Eurocube wandaansluitbocht voor douche met muurhouder, chromen afwerking en in Duitsland ontwikkeld.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/26370000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G334",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	},
	{
		"id": "34714000",
		"image": "//cdn.cloud.grohe.com/prod/30/34/34714000/640/34714000.jpg",
		"headline": "Grohtherm SmartControl",
		"subheadline": "Douchethermostaat met 2 uitgangen",
		"textblock_1st_text": "34714000",
		"textblock_2nd_text": "GROHE Grohtherm SmartControl Combi douchemengkraan met twee afsluiters. Chroom met witte tray, gemaakt met Duitse techniek.",
		"links": [
			{
				"text": "results.product.information",
				"track_action": "product-details",
				"deeplink": "https://www.grohe.be/nl_be/product/34714000",
				"icon": "",
				"additionalClass": ""
			},
			{
				"text": "results.product.dealer",
				"track_action": "dealer-locator",
				"deeplink": "https://www.grohe.be/nl_be/onze-service/locator.html#productline=G422",
				"icon": "icon-result-button-location",
				"additionalClass": ""
			}
		]
	}
];


//////////////////
// WEBPACK FOOTER
// ./src/data/shower_products_nl_be.json
// module id = 835
// module chunks = 0